import { ENV } from "../services/apiManager/apiConfig";
import storePersist, { localConstant } from "../services/localStorage";

export const ZIP_CODE = [
  {
    value: "Alabama (AL)",
    label: "Alabama (AL)",
  },
  {
    value: "Alaska (AK)",
    label: "Alaska (AK)",
  },
  {
    value: "Arizona (AZ)",
    label: "Arizona (AZ)",
  },
  {
    value: "Arkansas (AR)",
    label: "Arkansas (AR)",
  },
  {
    value: "California (CA)",
    label: "California (CA)",
  },
];

export const HERE_ABOUT_US_MAPPINGS = [
  {
    id: "CUREF",
    title: "Customer Referral",
  },
  {
    id: "YRDMA",
    title: "Yard Manager",
  },
  {
    id: "GGADS",
    title: "Google Ads",
  },
  {
    id: "TRKPT",
    title: "Trucker Path",
  },
  {
    id: "TRKGU",
    title: "Trucker Guide",
  },
  {
    id: "BLBRD",
    title: "Billboard",
  },
  {
    id: "FLYER",
    title: "Flyer",
  },
  {
    id: "OTHER",
    title: "Other",
  },
];

const companyObject = {
  countryCode: "USA",
  creationUser: "system",
  lastUpdatedUser: "system",
  status: "A",
  isCompany: true,
};

export default companyObject;

export const generateUUID = () => {
  // Public Domain/MIT
  var d = new Date().getTime(); //Timestamp
  var d2 =
    (typeof performance !== "undefined" &&
      performance.now &&
      performance.now() * 1000) ||
    0; //Time in microseconds since page-load or 0 if unsupported
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = ((d + r) % 16) | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = ((d2 + r) % 16) | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
};

export const retreiveURL = (str) => {
  const url = str[0];
  return url;
};

export const getVehicleType = (type) => {
  switch (type) {
    case "TRUCK":
      return "TRUCK";
    case "Truck":
      return "TRUCK";
    case "TRALR":
      return "TRAILER";
    case "Trailer":
      return "TRAILER";
    case "PERVEH":
      return "PERSONAL VEHICLE";
    case "PersonalV":
      return "PERSONAL VEHICLE";
    default:
      return "";
  }
};

export const getDate = (dateString) => {
  const date = new Date(dateString);
  const formattedDate = `${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}/${date
    .getDate()
    .toString()
    .padStart(2, "0")}/${date.getFullYear()}`;
  return formattedDate;
};
export const convert24HourTo12Hour = (time) => {
  if (!time) return "";

  // Split the time string into hours and minutes
  const [hours, minutes] = time?.split(":");

  // Convert the hours part to a number to make calculations easier
  const hoursNumeric = parseInt(hours, 10);

  // Determine AM or PM
  const period = hoursNumeric >= 12 ? "PM" : "AM";

  // Convert 24-hour time to 12-hour time
  const hoursIn12HourFormat = hoursNumeric % 12 || 12;

  // Return the formatted time string
  return `${hoursIn12HourFormat}:${minutes} ${period}`;
};

export const addOneMonth = (dateString) => {
  if (!dateString) return;
  const date = new Date(dateString);
  date.setMonth(date.getMonth() + 1);
  if (date.getMonth() !== (new Date(dateString).getMonth() + 1) % 12) {
    date.setDate(0); // setDate(0) sets the date to the last day of the previous month
  }

  return date.toISOString();
};
export const sendMessageToReactNative = (message) => {
  if (window.ReactNativeWebView) {
    if (message !== undefined) {
      window.ReactNativeWebView.postMessage(message);
    }
  }
};
export const isMobileDeviceCheck = () => {
  const isNativeMobile = storePersist.get(localConstant.IS_NATIVE_APP_LAUNCHED);
  const isFromNative = window.navigator.userAgent.includes("wv");
  console.log("native event on app load", isNativeMobile, isFromNative);
  return isNativeMobile || isFromNative;
};

export const mobileLatestVersionQA = () => {
  const LATEST_MOBILE_APP_VERSION_QA_ANDROID = "2.9.0";
  const LATEST_MOBILE_APP_VERSION_QA_IOS = "2.9.0";
  return {
    android: LATEST_MOBILE_APP_VERSION_QA_ANDROID,
    ios: LATEST_MOBILE_APP_VERSION_QA_IOS,
  };
};

export const mobileLatestVersionProd = () => {
  const LATEST_MOBILE_APP_VERSION_PROD_ANDROID = "1.0.3";
  const LATEST_MOBILE_APP_VERSION_PROD_IOS = "1.2";
  return {
    android: LATEST_MOBILE_APP_VERSION_PROD_ANDROID,
    ios: LATEST_MOBILE_APP_VERSION_PROD_IOS,
  };
};

export const truncateLocationName = (facilityName) => {
  const prefix = "Safe Truck Parking - ";
  return facilityName?.startsWith(prefix)
    ? facilityName?.slice(prefix.length)
    : facilityName;
};

export const isMobileDeviceCheckByUserAgent = () => {
  const regex =
    /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const isMobileCheck = regex.test(window.navigator.userAgent);
  console.log("window.navigator.userAgent", window);
  return isMobileCheck;
};

// it will fetch the device name.
export const getDeviceName = () => {
  const userAgent = navigator.userAgent;

  if (/android/i.test(userAgent)) {
    return "Android App";
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "IOS App";
  }

  return "Web App";
};

export const isAppInLatestVersion = (appCurrentVersion) => {
  if (appCurrentVersion === null) return true;
  const appLatestVersion =
    getDeviceName() === "Android App"
      ? ENV.latestMObileVersion.android
      : ENV.latestMObileVersion.ios;

  if (appCurrentVersion >= appLatestVersion) {
    return true;
  }
  return false;
};
